/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import {EEmbededElementTypes, RenderDocument} from "js_renderer";
import Factory from "../factory";
import TexturedQuad from "./textured_quad";
import {vec2} from "gl-matrix";
import Point from "../point";

export default
class SightPoint extends TexturedQuad {

    public static TypeName: string = EEmbededElementTypes.SIGHTPOINT;

    constructor(aRenderDocument: RenderDocument) {
        super(aRenderDocument);

        this.extendProperties({
            textureUrl: '@assets/images/points_texture.png',
            textureSize: vec2.clone(Point.texture_size),
            textureHasAlpha: true,
            glyphPosition: [32.0 / Point.texture_size[0], 0.0 / Point.texture_size[1]],
            glyphSize: [16.0 / Point.texture_size[0], 16.0 / Point.texture_size[1]], // TB: was 9x9
            pickable: false
        });
    }

    public static create(aRenderDocument: RenderDocument): SightPoint {
        let element = new SightPoint(aRenderDocument);
        element._typeName = SightPoint.TypeName;
        return element;
    }
}

Factory.register(SightPoint);
